

export const blue50 = '#e3f2fd';
export const blue500 = '#1976d2';
export const topNavBarColor = '#7C90A0';